import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AdditionalPublicLibraryService } from 'src/app/core/services/additional-public-library.service';
import { AdditionalPubLicLibrarySetting } from 'src/app/core/interface/auth.model';
import { SuccessMessageComponent } from 'src/app/components/all-modals/success-message/success-message.component';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ErrorMessageComponent } from 'src/app/components/all-modals/error-message/error-message.component';
import { REGEX_PATTERNS } from 'src/app/core/constants/regex-patterns.constant';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-setting-additional-public-library',
  templateUrl: './setting-additional-public-library.component.html',
  styleUrls: ['./setting-additional-public-library.component.scss']
})
export class SettingAdditionalPublicLibraryComponent implements OnInit {
  radiusForm: FormGroup;
  isSubmitted = false;
  radiusError = '';

  @Input() public user;
  settings = {
    geolocation_status: false,
    id: '',
    radius: 0,
    radius_unit: "m"
  }
  constructor(
    private activeModal: NgbActiveModal,
    private additionalService: AdditionalPublicLibraryService,
    private modalService: NgbModal,
    private spinner: NgxSpinnerService,
    private formBuilder: FormBuilder
  ) { }

  ngOnInit() {
    this.loadSettings();
    this.radiusForm = this.formBuilder.group({
      radius: ['', Validators.compose([Validators.required, Validators.min(0.000000000000000000000000001)])],
      radius_unit: ['']
    });
  }

  loadSettings() {
    this.spinner.show();
    this.additionalService.getAdditionalPublicLibrarySettings(this.user.id).subscribe((response) => {
      this.spinner.hide();
      this.settings = response.data.user_outlet;
      this.radiusForm.get('radius').setValue(this.settings.radius);
      this.radiusForm.get('radius_unit').setValue(this.settings.radius_unit);
    }, (error) => {
      this.spinner.hide()
    });
  }

  onSlideChange(type: any, value: any) {
    this.spinner.show();

    const params: AdditionalPubLicLibrarySetting = {
      user_outlet: {
        [type]: value
      }
    };
    this.additionalService.updateAdditionalPublicLibrarySettings(this.user.id, params).subscribe((response) => {
      this.spinner.hide();
      if (response.success) {
        const modalRef = this.modalService.open(SuccessMessageComponent, { centered: true });
        modalRef.componentInstance.message = "Updated successfully";
      } else if (response.errors && response.errors[0]) {
        if (type == 'radius') {
          this.radiusError = response.errors[0];
        } else {
          const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
          modalRef.componentInstance.message = response.errors[0];
        }
      } else {
        const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
        modalRef.componentInstance.message = "Error ouccured during updating a setting";
      }
    }, (error) => {
      this.spinner.hide();
      const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
      modalRef.componentInstance.message = "Error ouccured during updating a setting";
    });
  }
  updatePhone() {
    this.isSubmitted = true;
    if (!this.radiusForm.valid) {
      return;
    }
    this.radiusError = '';
    this.onSlideChange("radius", this.radiusForm.get('radius').value);
  }

  /**
  * restrict e . + -
  *
  * @param {*} event
  * @returns
  * @memberof AddTokensComponent
  */
  restrictNumeric(event) {
    //firefox solution
    event = event || window.event;
    var charCode = (typeof event.which == "undefined") ? event.keyCode : event.which;
    var charStr = String.fromCharCode(charCode);


    let restrictKeycodes = [101, 43, 45];
    if (event.target.value && event.target.value.includes('.')) {
      restrictKeycodes.push(46);
      if (!charStr.match(/^[0-9]+$/))
        event.preventDefault();
    } else {
      if (!charStr.match(/^[0-9.]+$/))
        event.preventDefault();
    }

    if (restrictKeycodes.includes(event.keyCode) || event.target.value.length > 10) {
      return false;
    }
  }

  restrictNumericPaste(event) {
    let text = event.clipboardData.getData('text').toString();
    let filteredText = text.replace(REGEX_PATTERNS.NUMBER_REMOVE_DE, "");
    let radius = (this.radiusForm.get('radius').value) ? (this.radiusForm.get('radius').value.toString() + filteredText) : filteredText

    this.radiusForm.patchValue({
      radius: radius.substring(0, 12)
    });

    event.preventDefault();
  }

  closeDialog() {
    this.activeModal.dismiss();
  }
}
